export default __webpack_public_path__ + "static/media/cert-hr-hkgcsmeaa.782404f8.jpg";